import React from 'react';

export default ({ record }) => {
  return (
    <span>
      Model
      {record ? `: ${record.name}` : ''}
    </span>
  );
};



// WEBPACK FOOTER //
// ./src/containers/CarModel/Title.js